import {ICDNode} from "./types/ICDNode";
import {LabelAndValue} from "./types/LabelAndValue";

export interface SearchResult {
    matched: LabelAndValue[]
    unmatched: string[]
}

const isCodeOrGroup = (key: string) => {
    return key.startsWith('3_') || key.startsWith('4_')
}

const isRelated = (key: string, title: string) => {
    return key.substring(0, 1) === title.substring(0, 1)
}

const matchingNodes = (d: ICDNode, k: string): LabelAndValue[] => {
    // don't need to search children if there an exact match
    if (d.code === k) {
        return [{label: d.title, value: d.code}]
    } else if (d.children) {
        return findMatchingNodes(k, d.children).matched
    } else {
        return []
    }
}

export const findMatchingNodes = (key: string, data: ICDNode[]): SearchResult => {
    const keys = key
        .split(',')
        .map(s => s.trim().toUpperCase())
        .filter(i => i.length >= 3 && i.length <= 4);
    const matching = keys.flatMap(k => {
        return data.flatMap(d => {
            if (isCodeOrGroup(d.key)) {
                // don't need to search if codes are not of a related hierarchy
                if (isRelated(key, d.title)) {
                    return matchingNodes(d, k)
                } else {
                    return []
                }
            } else {
                return matchingNodes(d, k)
            }
        })
    })

    const matchedKeys = matching.map(i => i.value)
    const unmatchedKeys = keys.filter(i => !matchedKeys.includes(i))
    return {
        'matched': matching,
        'unmatched': unmatchedKeys
    }
}